module.exports = __webpack_public_path__ + "img/134.10.53343583.png";